import { breakpoints } from '../../../constants';
import { eventThrottle } from '../../../utility';
import triggerWindowResize from '../../../utility/triggerWindowResize';
import GlideSlider from '../base';

const glideOptions = {
  type: 'slider',
  startAt: 0,
  perView: 3,
  peek: 16,
  rewind: false,
  bound: true,
  gap: 10,
  breakpoints: {
    [breakpoints['break-2']]: {
      perView: 2,
    },
    650: {
      perView: 1,
    },
  },
};

export default class featuredCalloutsSlider {
  constructor(el) {
    this.el = el;
    this.state = {
      activeSlider: false,
    };
    this.initSlider();
    this.initialSliderMount();
    triggerWindowResize();
    window.addEventListener('resize', eventThrottle(() => this.handleSlider(), 200));
  }

  initSlider() {
    this.featuredCalloutsSlider = new GlideSlider(
      this.el,
      glideOptions,
    );

    this.featuredCalloutsSliderGlideInstance = this.featuredCalloutsSlider.getGlideSlider();
  }

  initialSliderMount() {
    // Determine if screen size is less than break-2 and mount slider if so
    if (!window.matchMedia(`(min-width: ${breakpoints['break-2']}px)`).matches) {
      this.featuredCalloutsSliderGlideInstance.mount();
      this.state.activeSlider = true;
    }
  }

  handleSlider() {
    if (window.matchMedia(`(min-width: ${breakpoints['break-2']}px)`).matches && this.state.activeSlider) {
      this.featuredCalloutsSliderGlideInstance.destroy();
      this.state.activeSlider = false;
    } else if (!window.matchMedia(`(min-width: ${breakpoints['break-2']}px)`).matches && !this.state.activeSlider) {
      this.initSlider();
      this.featuredCalloutsSliderGlideInstance.mount();
      this.state.activeSlider = true;
    }
  }
}
